export default class ProjetoBeneficiario {
    
    constructor(model = null){

        this.empresaId = 0;
        this.projetoId = 0;
        this.beneficiarioId = 0;
        this.dataEntrada = '';
        this.dataSaida = '';

        if (!model)
            return;
        
        this.empresaId = model.empresaId;
        this.projetoId = model.projetoId;
        this.beneficiarioId = model.beneficiarioId;
        this.beneficiario = model.beneficiario;
        this.dataEntrada = new Date(model.dataEntrada).yyyymmdd();
        this.dataSaida = model.dataSaida ? new Date(model.dataSaida).yyyymmdd() : null;
    }

}